export default {
      id: "warning-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#warning",
      toString: function () {
        return this.url;
      }
    }